import { EntityReport } from "../../entity/EntityReport";

export class DtoReportsPutRes extends EntityReport {}
